export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 64;

export const getPasswordRequirements = password => {
  const value = typeof password === "string" ? password : "";

  return {
    length:
      value.length >= PASSWORD_MIN_LENGTH &&
      value.length <= PASSWORD_MAX_LENGTH,
    uppercase: /[A-Z]/.test(value),
    lowercase: /[a-z]/.test(value),
    number: /\d/.test(value),
    special: /[^A-Za-z0-9\s]/.test(value),
    noWhitespace: !/\s/.test(value),
  };
};

export const isPasswordValid = password =>
  Object.values(getPasswordRequirements(password)).every(Boolean);
